<template>
    <template v-if="fullLocation">
        <h2 class="text-sm text-gray-600 flex items-baseline gap-1">
            <i class="icon-map-pin-solid"></i>
            <span class="line-clamp-2">
                {{ fullLocation }}
            </span>
        </h2>
    </template>
</template>

<script setup>
defineProps({
    fullLocation: {
        type: String,
        default: null,
    },
})
</script>
